module.exports = {"HAS_DELIVERY_FROM_STORE":false,"HAS_INSTALLMENT_OPTIONS":false,"BARCODE_TIME_LIMIT_IN_MINUTES":30}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/checkout.json
// module id = 197
// module chunks = 1